import { Dialog } from '@angular/cdk/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type YoutubeDialogData = {
  videoUrl:string;
}

@Component({
    selector: 'app-youtube-video-dialog.',
    templateUrl: './youtube-video-dialog.component.html',
    styleUrls: ['./youtube-video-dialog.component.scss'],
    standalone: false
})
export class YoutubeVideoDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: YoutubeDialogData,
    private dialogRef: MatDialogRef<YoutubeVideoDialogComponent>
  ) { }


  ngOnInit(): void {
    this.dialogRef.backdropClick().subscribe(() => {
      console.log("on backdrop click");
      this.dialogRef.close();
    });
  }

  public static open(
    dialogService: MatDialog,
    data: YoutubeDialogData
  ): MatDialogRef<YoutubeVideoDialogComponent, void> {
    return dialogService.open<
      YoutubeVideoDialogComponent, YoutubeDialogData, void
    >(
      YoutubeVideoDialogComponent,
      {
        data: data,
        width: '100vw',
        maxWidth: '100vw',
        height:'100vh',
        disableClose:false,
        maxHeight:'100vh',
        scrollStrategy: new NoopScrollStrategy(),
        panelClass: ['invisible-panel', 'no-added-padding'],
        backdropClass: ['dark-backdrop', 'blur-backdrop']
      }
    );
  }

}